<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Impresoras C2326, C3224, C3326, C3426, CS331, CS431, CS439">
     Impresoras C2326, C3224, C3326, C3426, CS331, CS431, CS439
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_es" title="Informaci&oacute;n de seguridad">
     Informaci&oacute;n de seguridad
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Convenciones">
      Convenciones
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e42" title="Instrucciones del producto">
      Instrucciones del producto
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learn-about-printer-chapter.html#learn-about-printer-chapter_es" title="Informaci&oacute;n acerca de la impresora">
     Informaci&oacute;n acerca de la impresora
    </a>
   </p>
   <div id="divd0e173">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_es" title="B&uacute;squeda de informaci&oacute;n sobre la impresora">
      B&uacute;squeda de informaci&oacute;n sobre la impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_es" title="B&uacute;squeda del n&uacute;mero de serie de la impresora">
      B&uacute;squeda del n&uacute;mero de serie de la impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_es" title="Configuraciones de la impresora">
      Configuraciones de la impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_es" title="Uso del panel de control">
      Uso del panel de control
     </a>
    </p>
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_es" title="Personalizaci&oacute;n de la pantalla de inicio">
      Personalizaci&oacute;n de la pantalla de inicio
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_es" title="Interpretaci&oacute;n del estado del indicador">
      Interpretaci&oacute;n del estado del indicador
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e628" title="Selecci&oacute;n del papel">
      Selecci&oacute;n del papel
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setup-install-and-configure-chapter.html#setup-install-and-configure-chapter_es" title="Montaje, instalaci&oacute;n y configuraci&oacute;n">
     Montaje, instalaci&oacute;n y configuraci&oacute;n
    </a>
   </p>
   <div id="divd0e1352">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_es" title="Selecci&oacute;n de una ubicaci&oacute;n para la impresora">
      Selecci&oacute;n de una ubicaci&oacute;n para la impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_es" title="Conexi&oacute;n de cables">
      Conexi&oacute;n de cables
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-optional-trays-topic.html#installing-optional-trays_es" title="Instalaci&oacute;n de bandejas opcionales">
      Instalaci&oacute;n de bandejas opcionales
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-cloud-connector-profile-topic.html#d0e1550" title="Configuraci&oacute;n y uso de las aplicaciones de la pantalla de inicio">
      Configuraci&oacute;n y uso de las aplicaciones de la pantalla de inicio
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-paper-size-and-type-topic.html#d0e1677" title="Carga de papel y material especial">
      Carga de papel y material especial
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e1852" title="Instalaci&oacute;n y actualizaci&oacute;n de software, controladores y firmware">
      Instalaci&oacute;n y actualizaci&oacute;n de software, controladores y firmware
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e2112" title="Conexi&oacute;n en red">
      Conexi&oacute;n en red
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-h1-topic.html#printing-menu-settings-page-h1_es" title="Impresi&oacute;n de la p&aacute;gina de valores de men&uacute;">
      Impresi&oacute;n de la p&aacute;gina de valores de men&uacute;
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="secure-printer-chapter.html#secure-printer-chapter_es" title="C&oacute;mo proteger la impresora">
     C&oacute;mo proteger la impresora
    </a>
   </p>
   <div id="divd0e2557">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_es" title="Borrado de memoria de la impresora">
      Borrado de memoria de la impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_es" title="Restauraci&oacute;n de los valores predeterminados de f&aacute;brica">
      Restauraci&oacute;n de los valores predeterminados de f&aacute;brica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_es" title="Declaraci&oacute;n de volatilidad">
      Declaraci&oacute;n de volatilidad
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="print-chapter.html#print-chapter_es" title="Impresi&oacute;n">
     Impresi&oacute;n
    </a>
   </p>
   <div id="divd0e2679">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_es" title="Impresi&oacute;n desde un ordenador">
      Impresi&oacute;n desde un ordenador
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e2705" title="Impresi&oacute;n desde un dispositivo m&oacute;vil">
      Impresi&oacute;n desde un dispositivo m&oacute;vil
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_es" title="Configuraci&oacute;n de trabajos confidenciales">
      Configuraci&oacute;n de trabajos confidenciales
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_es" title="Impresi&oacute;n de trabajos confidenciales y otros trabajos en espera">
      Impresi&oacute;n de trabajos confidenciales y otros trabajos en espera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-cloud-connector-profile-topic.html#printing-from-cloud-connector-profile_es" title="Impresi&oacute;n desde un perfil de Conector en la nube">
      Impresi&oacute;n desde un perfil de Conector en la nube
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-topic.html#printing-font-sample-lis_es" title="Impresi&oacute;n de una lista de muestras de fuentes">
      Impresi&oacute;n de una lista de muestras de fuentes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_es" title="Colocaci&oacute;n de hojas de separaci&oacute;n entre copias">
      Colocaci&oacute;n de hojas de separaci&oacute;n entre copias
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_es" title="Cancelaci&oacute;n de un trabajo de impresi&oacute;n">
      Cancelaci&oacute;n de un trabajo de impresi&oacute;n
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_es" title="Ajuste de intensidad del t&oacute;ner">
      Ajuste de intensidad del t&oacute;ner
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_es" title="Uso de los men&uacute;s de la impresora">
     Uso de los men&uacute;s de la impresora
    </a>
   </p>
   <div id="divd0e3247">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menus-map-mfp_es" title="Mapa de men&uacute;s">
      Mapa de men&uacute;s
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e3504" title="Dispositivo">
      Dispositivo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e4996" title="Impresi&oacute;n">
      Impresi&oacute;n
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e5944" title="Papel">
      Papel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e6184" title="Red/puertos">
      Red/puertos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e8174" title="Seguridad">
      Seguridad
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-connector-menu-topic.html#cloud-connector-menu_es" title="Cloud Connector">
      Cloud Connector
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e8830" title="Informes">
      Informes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_es" title="Soluci&oacute;n de problemas">
      Soluci&oacute;n de problemas
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_es" title="Mantenimiento de la impresora">
     Mantenimiento de la impresora
    </a>
   </p>
   <div id="divd0e9032">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_es" title="Comprobaci&oacute;n del estado de suministros y piezas">
      Comprobaci&oacute;n del estado de suministros y piezas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_es" title="Configuraci&oacute;n de notificaciones de suministros">
      Configuraci&oacute;n de notificaciones de suministros
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_es" title="Configuraci&oacute;n de alertas de correo">
      Configuraci&oacute;n de alertas de correo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_es" title="Visualizaci&oacute;n de informes">
      Visualizaci&oacute;n de informes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_es" title="Pedido de consumibles y piezas">
      Pedido de consumibles y piezas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-print-cartridge-topic.html#d0e9851" title="Sustituci&oacute;n de consumibles y piezas">
      Sustituci&oacute;n de consumibles y piezas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e10049" title="Limpieza de las piezas de la impresora">
      Limpieza de las piezas de la impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e10170" title="Ahorro de energ&iacute;a y papel">
      Ahorro de energ&iacute;a y papel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_es" title="Desplazamiento de la impresora a otra ubicaci&oacute;n">
      Desplazamiento de la impresora a otra ubicaci&oacute;n
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_es" title="Env&iacute;o de la impresora">
      Env&iacute;o de la impresora
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshoot-problem-chapter.html#troubleshoot-problem-chapter_es" title="Soluci&oacute;n de problemas">
     Soluci&oacute;n de problemas
    </a>
   </p>
   <div id="divd0e10332">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_es" title="Problemas de calidad de impresi&oacute;n">
      Problemas de calidad de impresi&oacute;n
     </a>
    </p>
    <p class="toc-2-style">
     <a href="print-quality-is-poor-subgroup.html#d0e10432" title="Problemas de impresi&oacute;n">
      Problemas de impresi&oacute;n
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_es" title="La impresora no responde">
      La impresora no responde
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e12837" title="Problemas de conexi&oacute;n de red">
      Problemas de conexi&oacute;n de red
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e13056" title="Problemas con los consumibles">
      Problemas con los consumibles
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_es" title="Eliminaci&oacute;n de atascos">
      Eliminaci&oacute;n de atascos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e13493" title="Problemas de alimentaci&oacute;n del papel">
      Problemas de alimentaci&oacute;n del papel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e13875" title="Problemas de calidad de color">
      Problemas de calidad de color
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_es" title="Contacto con el servicio de atenci&oacute;n al cliente">
      Contacto con el servicio de atenci&oacute;n al cliente
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_es" title="Reciclaje y eliminaci&oacute;n">
     Reciclaje y eliminaci&oacute;n
    </a>
   </p>
   <div id="divd0e14114">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_es" title="Reciclaje de los productos de Lexmark">
      Reciclaje de los productos de Lexmark
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_es" title="Reciclaje de embalajes Lexmark">
      Reciclaje de embalajes Lexmark
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_es" title="Avisos">
     Avisos
    </a>
   </p>
   <div id="divd0e14149">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14152" title="Informaci&oacute;n de producto">
      Informaci&oacute;n de producto
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14169" title="Nota sobre la edici&oacute;n">
      Nota sobre la edici&oacute;n
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_es" title="Marcas comerciales">
      Marcas comerciales
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_es" title="Avisos de licencia">
      Avisos de licencia
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_es" title="Niveles de emisi&oacute;n de ruido">
      Niveles de emisi&oacute;n de ruido
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_es" title="Directiva de residuos de aparatos el&eacute;ctricos y electr&oacute;nicos (WEEE)">
      Directiva de residuos de aparatos el&eacute;ctricos y electr&oacute;nicos (WEEE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14266" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_es" title="Informaci&oacute;n para el desecho de los productos">
      Informaci&oacute;n para el desecho de los productos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14300" title="Bater&iacute;a recargable de iones de litio">
      Bater&iacute;a recargable de iones de litio
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_es" title="Normativa (UE) 2023/1542">
      Normativa (UE) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_es" title="Devoluci&oacute;n de los cartuchos Lexmark para su reutilizaci&oacute;n o reciclado">
      Devoluci&oacute;n de los cartuchos Lexmark para su reutilizaci&oacute;n o reciclado
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_es" title="Aviso sobre sensibilidad est&aacute;tica">
      Aviso sobre sensibilidad est&aacute;tica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_es" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_es" title="Informaci&oacute;n acerca de la temperatura">
      Informaci&oacute;n acerca de la temperatura
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#mexico-energy-information_es" title="Informaci&oacute;n de la energ&iacute;a de M&eacute;xico">
      Informaci&oacute;n de la energ&iacute;a de M&eacute;xico
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_es" title="Aviso de l&aacute;ser">
      Aviso de l&aacute;ser
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_es" title="Consumo de energ&iacute;a">
      Consumo de energ&iacute;a
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14561" title="Avisos sobre normativa relativos a productos inal&aacute;mbricos">
      Avisos sobre normativa relativos a productos inal&aacute;mbricos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_es" title="Aviso sobre componentes modulares">
      Aviso sobre componentes modulares
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_es" title="Exposici&oacute;n a radiaci&oacute;n de radiofrecuencia">
      Exposici&oacute;n a radiaci&oacute;n de radiofrecuencia
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14587" title="Para su uso en M&eacute;xico">
      Para su uso en M&eacute;xico
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14592" title="Conformidad con las directivas de la Comunidad Europea (CE)">
      Conformidad con las directivas de la Comunidad Europea (CE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-b_es" title="Conformidad con las directivas de la Comunidad Europea (CE)">
      Conformidad con las directivas de la Comunidad Europea (CE)
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue